'use client';

import { c as _c } from "react/compiler-runtime";
import checkThickIcon from '@public/images/check_thick.svg';
import Image from 'next/image';
import { FavoriteButton } from '@src/components/FavoriteButton/FavoriteButton';
import { useIsMobileLandscape } from '@src/hooks/useIsMobileLandscape';
import { useLocale } from '@src/i18n/LocaleProvider';
import { getTrainerText } from '@src/mappers/media/media-display.helpers';
import { POST_WORKOUT_SCREEN_NAME, trackAddToFavorites, trackRemoveFromFavorites } from '@src/utils/post-workout-analytics.util';
import { cn } from '@src/utils/tailwind';
type PostWorkoutWorkoutCardProps = {
  entityData?: CocoApi.WorkoutEntity;
  className?: string;
};
export function PostWorkoutWorkoutCard(t0) {
  const $ = _c(33);
  const {
    entityData,
    className
  } = t0;
  const {
    t
  } = useLocale("common");
  const isMobileLandscape = useIsMobileLandscape();
  if (!entityData || isMobileLandscape) {
    return null;
  }
  let t1;
  if ($[0] !== entityData || $[1] !== t) {
    t1 = getTrainerText(entityData, t("with"));
    $[0] = entityData;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const trainerText = t1;
  let t2;
  if ($[3] !== className) {
    t2 = cn("relative w-full max-w-full shrink overflow-hidden rounded-[30px]", "aspect-322/220 lg:aspect-25/17", className);
    $[3] = className;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = entityData.title ?? "";
  const t4 = entityData.thumbnail?.url ?? (entityData as CocoApi.EditorialEntity).image?.url ?? "";
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <Image alt={t3} className="absolute inset-0 size-full object-cover" width={782} height={532} src={t4} />;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="absolute inset-0 bg-linear-to-t from-bodi-black-text via-bodi-black-text/45 to-transparent lg:hidden" />;
    t7 = <div className="absolute inset-0 hidden bg-linear-to-t from-bodi-black-text/80 to-transparent lg:block" />;
    $[8] = t6;
    $[9] = t7;
  } else {
    t6 = $[8];
    t7 = $[9];
  }
  const t8 = entityData.userData?.isFavorited ?? false;
  let t9;
  if ($[10] !== entityData._type || $[11] !== entityData.primaryParent?.slug || $[12] !== entityData.slug || $[13] !== entityData.title) {
    t9 = isFavorited => {
      const analytics = {
        screenName: POST_WORKOUT_SCREEN_NAME,
        slug: entityData.slug ?? "",
        title: entityData.title ?? "",
        type: entityData._type,
        parentSlug: entityData.primaryParent?.slug
      };
      if (isFavorited) {
        trackAddToFavorites(analytics);
      } else {
        trackRemoveFromFavorites(analytics);
      }
    };
    $[10] = entityData._type;
    $[11] = entityData.primaryParent?.slug;
    $[12] = entityData.slug;
    $[13] = entityData.title;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== entityData._id || $[16] !== entityData._type || $[17] !== t8 || $[18] !== t9) {
    t10 = <div className="absolute top-4 right-6 z-10 lg:top-8 lg:right-8"><FavoriteButton entityId={entityData._id} entityType={entityData._type} isFavorited={t8} size="large" tone="light" removeOutline={true} onFavoriteClick={t9} /></div>;
    $[15] = entityData._id;
    $[16] = entityData._type;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="flex size-10 items-center justify-center rounded-full bg-bodi-accent-bright-500"><Image width={27} height={27} alt="" src={checkThickIcon} /></div>;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== entityData.title) {
    t12 = <p className="m-0 text-body-base font-medium text-bodi-white">{entityData.title}</p>;
    $[21] = entityData.title;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== trainerText) {
    t13 = trainerText && <p className="m-0 text-body-xs text-bodi-gray-pearl">{trainerText}</p>;
    $[23] = trainerText;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t12 || $[26] !== t13) {
    t14 = <div className="absolute right-0 bottom-0 left-0 flex flex-col gap-1 p-6 lg:p-8">{t11}{t12}{t13}</div>;
    $[25] = t12;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t10 || $[29] !== t14 || $[30] !== t2 || $[31] !== t5) {
    t15 = <div className={t2}>{t5}{t6}{t7}{t10}{t14}</div>;
    $[28] = t10;
    $[29] = t14;
    $[30] = t2;
    $[31] = t5;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  return t15;
}